import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  firstDot: {
    marginLeft: 0,
  },
  focusedDot: {
    backgroundColor: Theme.enabledColor,
  },
  indicatorDot: {
    backgroundColor: Theme.disabledColor,
    borderRadius: Theme.px(6),
    height: Theme.px(12),
    marginLeft: Theme.px(12),
    width: Theme.px(12),
  },
  pageIndicator: {
    alignItems: 'center',
    flexDirection: 'row',
    height: Theme.px(12),
    justifyContent: 'center',
    position: 'absolute',
    top: Theme.px(1004),
    width: Theme.px(1920),
  },
});
